import React, { useState } from "react";
import { api } from "@/lib/caesar";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function ResetPassword() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) return setError("Password must be at least 8 characters");
    if (pw !== pw2) return setError("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
      toast.success("Password set. You can sign in now.");
      setTimeout(() => { window.location.href = "/login"; }, 1500);
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid or expired link");
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "w-full h-12 rounded-lg bg-surface border border-edge px-4 outline-none focus:border-gold/50";

  return (
    <div className="min-h-screen bg-ink text-[#FAFAFA] flex items-center justify-center px-6">
      <div className="w-full max-w-sm animate-fade-up">
        <img src="/szr-logo.png" alt="SZR" className="mx-auto w-32 h-32 object-contain" />
        <h1 className="font-display text-2xl font-extrabold text-center mt-2">Set Your Password</h1>
        {!token ? (
          <p data-testid="reset-no-token" className="text-sred text-sm text-center mt-4">Missing reset token. Please use the link provided to you.</p>
        ) : done ? (
          <p data-testid="reset-done" className="text-sgreen text-sm text-center mt-4">Password set. Redirecting to sign in…</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3" data-testid="reset-form">
            <div className="relative">
              <input data-testid="reset-password" type={show ? "text" : "password"} required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" className={inputCls + " pr-12"} />
              <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#A3A3A3] hover:text-gold">{show ? <EyeOff size={18} /> : <Eye size={18} />}</button>
            </div>
            <input data-testid="reset-password-confirm" type={show ? "text" : "password"} required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirm password" className={inputCls} />
            {error && <p data-testid="reset-error" className="text-sred text-sm">{error}</p>}
            <button data-testid="reset-submit" disabled={busy} type="submit" className="w-full h-12 rounded-lg bg-gold text-ink font-bold hover:bg-[#e6c14e] transition-colors disabled:opacity-60">{busy ? "…" : "SET PASSWORD"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
